import View from 'views/base/view';
import TranscriptTemplate from 'views/transcript/templates/transcript';

const TranscriptView = View.extend({
  autoRender: true,
  autoAttach: true,
  region: 'siteTranscript',
  template: TranscriptTemplate,
  initialize: function (options) {
    this.model.set('transcript', this.model.get('transcriptNarration'));
    View.prototype.initialize.apply(this, arguments);
  },
});

export default TranscriptView;
